/**
 * Проверки формы организации — те же, что делает сервер (slq-backend,
 * OrganizationAdminService). Здесь они нужны, чтобы подсветить поле сразу, а не
 * после запроса; последнее слово всё равно за сервером.
 */

/** Латиница, цифры и подчёркивание: код уходит в client_type заказов и в ключи тарифов. */
export const COMPANY_NAME = /^[A-Za-z0-9_]{2,50}$/;
export const BIN = /^\d{12}$/;
export const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

const blank = (value) => value == null || String(value).trim() === "";

/**
 * Ошибки по полям: { поле: текст }. Пустой объект — форму можно отправлять.
 * companyName проверяется только при создании: потом он не меняется.
 */
export const validateOrganization = (form, { isCreate }) => {
  const errors = {};

  if (isCreate && !COMPANY_NAME.test(String(form.companyName ?? "").trim())) {
    errors.companyName = "От 2 до 50 символов: латиница, цифры и _";
  }
  if (!BIN.test(String(form.bin ?? "").trim())) {
    errors.bin = "12 цифр";
  }
  if (blank(form.phone)) {
    errors.phone = "Обязательно";
  }
  if (!blank(form.email) && !EMAIL.test(String(form.email).trim())) {
    errors.email = "Проверьте адрес";
  }
  if (blank(form.katoCode)) {
    errors.katoCode = "Выберите населённый пункт";
  }

  return errors;
};

/** Тело запроса: строки без пробелов по краям, пустой email — null. */
export const toRequest = (form, { isCreate }) => {
  const trim = (value) => (value == null ? "" : String(value).trim());
  const body = {
    bin: trim(form.bin),
    phone: trim(form.phone),
    email: trim(form.email) || null,
    katoCode: trim(form.katoCode),
  };
  return isCreate ? { companyName: trim(form.companyName), ...body } : body;
};
